import { NavLink } from 'modules/layout/components/PrivateNavBar';
import { hideLinksWhenInternalSourcingAreNotEnabled } from 'modules/layout/utils/hideLinksWhenInternalSourcingAreNotEnabled';
import { Paths } from 'services/navigation/paths';
import { OrganizationConfig } from 'services/organization/type';

type Props = {
  links: NavLink[];
  organizationConfig: OrganizationConfig | null;
  isHomeTabHidden: boolean;
  isCampaignsTabHidden: boolean;
  isAnalyseTabHidden: boolean;
};

export const hideLinksForOrganization = ({
  links,
  organizationConfig,
  isHomeTabHidden,
  isCampaignsTabHidden,
  isAnalyseTabHidden
}: Props) => {
  const flaggedLinks = links.filter((link) => {
    if (link.to === Paths.HOME) return !isHomeTabHidden;
    if (link.to === Paths.CAMPAIGNS) return !isCampaignsTabHidden;
    if (link.to === Paths.CANDIDATES_RANKING) return !isAnalyseTabHidden;
    return true;
  });

  return hideLinksWhenInternalSourcingAreNotEnabled(
    flaggedLinks,
    organizationConfig?.internalSourcingEnabled ?? false
  );
};
